<template>
  <div>
    <div class="category row">

      <p class="category_title">{{ getCategoryName(categoryId) }}</p>

      <div class="bar_section">
        <div class="prev_section">
          <div v-show="hasPrevious" @click="toPrevious" class="arrow left">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </div>
        </div>
        <div class="main_section">
          <router-link class="video"
                       v-for="v in filterdVideos"
                       :key="v.ytid"
                       :to="{name: 'video-player', params: {ytid: v.ytid }}"
                       :style="{ 'background-image': 'url(' + v.thumbnail + ')' }">
            <div class="overlay">
              <div class="caption">
                <div class="title-bg"><h4 class="title">{{ v.title }}</h4></div>
                <div class="note-bg"><p class="note">{{ v.note }}</p></div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="next_section">
          <div v-show="hasNext" @click="toNext" class="arrow right">
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

  import _ from 'lodash'
  import { VIDEO_CATEGORIES, toName } from '../consts'

  export default {
    props: ['categoryId', 'videos'],
    data () {
      return {
        size: 3,
        currentPage: 0
      }
    },
    computed: {
      hasNext () {
        return this.totalPage() > (this.currentPage + 1)
      },
      hasPrevious () {
        return this.currentPage > 0
      },
      offset () {
        return this.currentPage * this.size
      },
      filterdVideos () {
        return _.slice(this.videos, this.offset, this.offset + this.size)
      }
    },
    methods: {
      totalPage () {
        if (!this.videos) return 0
        return Math.ceil(this.videos.length / this.size)
      },
      toNext () {
        if (this.hasNext) {
          this.currentPage++
        }
      },
      toPrevious () {
        if (this.hasPrevious) {
          this.currentPage--
        }
      },
      getCategoryName (value) {
        return toName(VIDEO_CATEGORIES, value)
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../style/common";

  .category_title {
    padding: 20px 35px 5px;
    /*padding-bottom: 5px;*/
    margin: 0;
    font-size: 3rem;
  }

  .bar_section {
    width: 100%;
    height: 100%;
    display: table;

    .prev_section, .next_section, .main_section {
      box-sizing: border-box;
      display: table-cell;
      margin: 0;
      padding: 0;
      height: 100%;
    }
    .prev_section, .next_section {
      width: 35px;
      height: 100%;
      text-align: center;
      vertical-align: middle;
    }
    .main_section {
      width: auto;
    }
  }

  .arrow {
    i {
      font-size: 3rem;
    }
  }

  .video {

    //skeltonのcolumnの代替えでfloatをかける
    float: left;
    box-sizing: border-box;

    //captionの位置を指定したいから
    position: relative;

    height: 150px;
    width: 50%;

    background-position: center;
    background-size: cover;

    &:hover .overlay {
      opacity: 1;
    }
  }

  .overlay {
    height: 100%;
    width: 100%;

    background: rgba(0, 0, 0, .7);
    -webkit-transition: .6s;
    transition: .6s;
    opacity: 0;

  }

  .caption {

    //絶対値の位置指定
    /*position: absolute;*/
    /*top: 2rem;*/

    //color: $color_white;
    /*width: 100%;*/
    margin: 0;
    padding: 1rem;
    z-index: 5;
  }

  .title-bg {
    text-align: center;
  }

  .title {
    font-size: 1.3rem;
  }

  .note-bg {
    text-align: left;
  }

  .note {
    font-size: 0.1rem;
  }

  /* Larger than phablet */
  @media (min-width: 550px) {

    .container {
      margin: 0 auto;
      padding: 0;
    }

    .video {
      width: 33.33%;
      height: 200px;
    }

    .title {
      font-size: 1.5rem;
    }

    .note {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// VideoArchivesCategory.vue?754c337e